/* app/js/src/components/common/not-allowed-icon/not-allowed-icon.component.scss */
/*# sourceMappingURL=not-allowed-icon.component.css.map */
